import { Model } from '../models/model';

export abstract class DropdownModel extends Model {
  abstract get dropDownDisplayName(): string;
  abstract get dropDownValue(): Object;
}
